// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__iEPbl","arrow":"Menu_arrow__cr0Gj","nav":"Menu_nav__r5QVM","navItem":"Menu_navItem__o0yLx"};